<template>
  <div class="row">
    <div class="col-12 col-lg-6 offset-lg-3 d-flex align-items-center">
      <div class="card card-success w-100 mt-2 mt-md-5">
        <div class="card-header pt-4 pb-3">
          <div class="col-12">
            <router-link :to="{ name: 'home' }" class="row logo-link">
              <img :src="getLogoUrl()" :alt="getCompanyText('company_shortname')" class="logo" />
            </router-link>
          </div>
        </div>
        <div class="card-body text-center px-3 px-md-1 pb-4">
          <h4 class="text-highlighted mb-4">Vážený klient!</h4>
          <div>
            Vaše údaje budú teraz spracované našou spoločnosťou. O úspešnom
            ukončení registrácie a uzatvorení zmluvy Vás budeme obratom
            informovať.
          </div>
        </div>
        <div class="card-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessScreen"
};
</script>

<style lang="scss">
.card-success {
	.logo-link {
		width: 100%;
		
		.logo {
			text-align: center;
			margin: 0 auto;
			max-height: 40px;
		}
	}

  .card-body {
    width: 300px;
    padding: 0;
    margin: 40px auto;

    strong {
      display: block;
      font-size: 18px;
      margin-bottom: 25px;
    }

    span {
      display: block;
      font-size: 14px;
      line-height: 140%;
      //color: white;
      margin-bottom: 25px;
    }
  }
}
</style>
